import { fetchGameDetails } from 'modules/games/store/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGameDetails } from './use-game-details';

export const useGameDetailsFetch = (gameId: number, championshipId: number) => {
  const dispatch = useDispatch();
  const { isLoading } = useGameDetails();

  useEffect(() => {
    if (!isLoading) {
      dispatch(fetchGameDetails({ gameId, championshipId }));
    }
  }, [gameId, championshipId]);
};
